import { orderStatuses, webOrderStatuses } from '../constants/Orders'

export const getWebOrderStatus = (orderStatus) => {
  orderStatus = orderStatus ? orderStatus.trim().toLowerCase() : ''

  switch (orderStatus) {
    case orderStatuses.sent.toLowerCase():
      return webOrderStatuses.sent

    case orderStatuses.delivered.toLowerCase():
      return webOrderStatuses.delivered

    case orderStatuses.preparing.toLowerCase():
      return webOrderStatuses.preparing

    case orderStatuses.sending.toLowerCase():
      return webOrderStatuses.sending

    case orderStatuses.withIncidence.toLowerCase():
      return webOrderStatuses.withIncidence

    case orderStatuses.canceled.toLowerCase():
      return webOrderStatuses.canceled

    case orderStatuses.received.toLowerCase():
      return webOrderStatuses.received

    case orderStatuses.rejected.toLowerCase():
      return webOrderStatuses.rejected

    case orderStatuses.downloading.toLowerCase():
      return webOrderStatuses.downloading

    default:
      return null
  }
}
